import api from '@/api';

import { API_BASE_URL } from '..';
import {
  SaleItem,
  SaleItemCreate,
  SaleItemEdit,
  SaleItemHistoryRequest,
  SaleItemHistoryResponse,
} from './SaleItem.types';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API_BASE_URL}/sale-items`;

export async function createSaleItem(obj: SaleItemCreate) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as SaleItem;
}

export async function updateSaleItem(obj: SaleItemEdit) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as SaleItem;
}

export async function deleteSaleItem(saleId: number, itemId: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/sale/${saleId}/item/${itemId}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function saleItemHistory(params?: SaleItemHistoryRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/sale-item-history`,
    params,
  )) as unknown;

  return result as PageResult<SaleItemHistoryResponse>;
}
